import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { useImageStore } from '../store/ImageStore'
import { useConfigStore } from '../store/ConfigStore'
import { useEffect } from 'react'
import { useShallow } from 'zustand/shallow'

type Props = {
  children: React.ReactNode
  initialValue?: unknown
  config: Settings
}

export function Provider({ children, initialValue, config }: Props) {
  const [setConfig] = useConfigStore(useShallow((state) => [state.setConfig]))
  const [setInitialValue, selected] = useImageStore(useShallow((state) => [state.setInitialValue, state.selected]))

  useEffect(() => {
    if (initialValue && !selected?.length) {
      setInitialValue(initialValue)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    setConfig(config)
  }, [config, setConfig])

  const queryClient = new QueryClient()
  return <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
}
